export interface WindGeometry {
    count: number;
    attr: Uint8Array;
    segments: Uint8Array;
    rx: Int32Array;
    ry: Int32Array;
    deltas: Int16Array;
}

export async function decodeWindGeometry(
    data: ArrayBuffer,
): Promise<WindGeometry> {
    const stream = new Blob([data])
        .stream()
        .pipeThrough(new DecompressionStream("deflate"));
    const buffer = await new Response(stream).arrayBuffer();
    const view = new DataView(buffer);
    const version = view.byteLength >= 1 ? view.getUint8(0) : 0;
    if (view.byteLength < 4 || (version !== 2 && version !== 3)) {
        throw new Error("未対応の風ベクトルタイル形式です。");
    }
    const byte1 = view.getUint8(1);
    const shift = version === 3 ? byte1 >> 6 : byte1 >> 7;
    const biasBits = version === 3 ? byte1 & 0x3f : byte1 & 0x7f;
    const bias = biasBits !== 0 ? biasBits << 10 : 4096;
    const count = view.getUint16(2, true);
    const attr = new Uint8Array(count);
    const segments = new Uint8Array(count);
    const rx = new Int32Array(count);
    const ry = new Int32Array(count);
    let offset = 4;
    let totalSegments = 0;
    for (let index = 0; index < count; index++) {
        if (offset + 6 > view.byteLength) {
            throw new Error("風ベクトルタイルが途中で切れています。");
        }
        attr[index] = view.getUint8(offset);
        segments[index] = view.getUint8(offset + 1);
        rx[index] = (view.getUint16(offset + 2, true) << shift) - bias;
        ry[index] = (view.getUint16(offset + 4, true) << shift) - bias;
        totalSegments += segments[index];
        offset += 6;
    }
    if (offset + totalSegments * 12 > view.byteLength) {
        throw new Error("風ベクトルの曲線データが不足しています。");
    }
    const deltas = new Int16Array(totalSegments * 6);
    for (let index = 0; index < deltas.length; index++) {
        deltas[index] = view.getInt16(offset + index * 2, true);
    }
    return { count, attr, segments, rx, ry, deltas };
}
